import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export const RequirePasswordChange = () => {
  const auth = useSelector((state) => state.auth);
  console.log(auth);
  console.log(auth?.user?.for_change_password);
  if (auth?.isLoggedIn && auth?.user?.for_change_password === 1) {
    return <Navigate to="/auth/change-password" replace />;
  }

  return <Outlet />;
};